import { Grid } from "@mui/material";
import TitleCustom from "components/CustomTitle";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Footer from "layouts/Footer";
import { getSalesDataBySector } from "models/getSalesBySector";
import { useCallback, useEffect, useState } from "react";
import { getCatalogSectors, getSalesSummaryBySector } from "rest/requests";
import { ChartsBySector } from "./chartsBySector";
import { formatTableSalesBySector } from "./formatTableData";
import { getExcelData } from "./getExcelData";

//components
// @mui material components

// Data

function SalesBySector() {
  const [showChart, setShowChart] = useState(false);
  // ------ Year select ----------
  const [year, setYear] = useState(new Date().getFullYear());
  const current_year = new Date().getFullYear();
  const handleYear = (event) => {
    const {
      target: { value },
    } = event;
    if (value <= current_year) {
      setYear(value);
    }
  };
  // ------ Year select END----------

  // Getting needed data
  // const userData = user();
  // console.log(userData);

  const [salesBySectorData, setSalesBySectorData] = useState([]);

  const getData = useCallback(async () => {
    const dataTemp = await getSalesSummaryBySector(year);
    const catalogSectors = await getCatalogSectors();
    const _salesSummaryBySectorData = getSalesDataBySector(dataTemp, catalogSectors);
    setSalesBySectorData(_salesSummaryBySectorData);
  }, [year]);

  useEffect(() => {
    getData();
  }, [year]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <TitleCustom
        title={"Resumen de Ventas por Sector"}
        excelData={getExcelData(salesBySectorData)}
        excelName={"Reporte_Ventas_Por_Sector_" + year + ".xlsx"}
        showChart={showChart}
        setShowChart={setShowChart}
      ></TitleCustom>

      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container>
          <Grid item>
            <MDInput type="number" label="Year" value={year} onChange={handleYear} />
          </Grid>
        </Grid>
      </MDBox>
      <br></br>
      {showChart ? (
        <ChartsBySector companiesSalesBySector={salesBySectorData}></ChartsBySector>
      ) : salesBySectorData.length > 0 ? (
        <DataTable table={formatTableSalesBySector(salesBySectorData)} canSearch={true} />
      ) : (
        <div></div>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default SalesBySector;
